import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import Swal from 'sweetalert2';
import { ServiceCategory } from '../db/models/categories';
import { ProService } from '../db/models/pro-services';
import { SearchData } from '../db/models/search';
import { User } from '../db/models/user';
import { AuthenticationService } from '../services/authentication.service';
import { CategoryService } from '../services/category.service';
import { ProfessionalServiceService } from '../services/professional-service.service';
import { SearchService } from '../services/search.service';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {

  homeform: FormGroup;
  allservices: ProService[];
  serviceTotal = 0;

  searchData = new SearchData();
  categories :  ServiceCategory[];

  currentUser: User;

  constructor(private fb: FormBuilder,
              private pservice: ProfessionalServiceService,
              private spinner: NgxSpinnerService,
              private service: SearchService,
              private cservice: CategoryService,
              private authenticate: AuthenticationService,
              private router: Router)
    {

      this.authenticate.currentUser.subscribe(x => this.currentUser = x);

    }

  ngOnInit() {
    this.createSearchForm();
    this.getAllServices();
  }

  createSearchForm() {
    this.homeform = this.fb.group({
      category: [null],
      city: [null]
    })
  }

  getAllCategories() {
    this.cservice.getAllServiceCategories().subscribe(
      res => {
        this.categories = res;
      }
    )
  }

  get category() {
    return this.homeform.controls.category as FormControl;
  }

  get city() {
    return this.homeform.controls.city as FormControl;
  }

  mapEntity(): void {

    this.searchData.category = this.category.value;
    this.searchData.city = this.city.value;


  }

  performSearch() {
    // this.spinner.show();
    this.mapEntity();
    // console.log("Search Params", this.searchData);
    this.service.SearchParams = this.searchData
    this.router.navigate(['/search_results']);
  }

  getAllServices(){
    this.pservice.getAllProfessionalServices().subscribe(
      res => {
        this.allservices = res;
        this.serviceTotal = this.allservices.length;
      }
    )
  }

  somefunction(user: User){
    // console.log('Nothing');
    if(user.id == null){
      this.router.navigate(['/register_as'])
    } else {
      this.notificationAlert()
    }
  }

  notificationAlert(){
    Swal.fire({
      icon: 'warning',
      title: 'Alert',
      text:'Profile cannot manage multiple services',
      showDenyButton: false,
      focusConfirm: true,
      confirmButtonText: '<i class="fa fa-thumbs-up"></i> Ok',
    }).then((result) => {
      if(result.isConfirmed){
        this.abort();
      }
    })
  }

  abort(){
    this.router.navigate(['/'])
  }

}
